import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// import L from 'leaflet';
// import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
// import markerIcon from 'leaflet/dist/images/marker-icon.png';
// import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import type React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { queryClient } from './lib/queryClient';
import { registerServiceWorker } from './lib/registerServiceWorker';
import './index.css'; // Only essential global CSS - everything else converted to Tailwind

// Fix Leaflet default icon issue with Vite
// interface LeafletIconDefault extends L.Icon<L.IconOptions> {
//   _getIconUrl?: () => string;
// }

// (L.Icon.Default.prototype as LeafletIconDefault)._getIconUrl = undefined;
// L.Icon.Default.mergeOptions({
//   iconUrl: markerIcon,
//   iconRetinaUrl: markerIcon2x,
//   shadowUrl: markerShadow,
// });

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key');
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);
root.render(
  <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
    <QueryClientProvider client={queryClient}>
      <App />
      {import.meta.env.MODE !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </ClerkProvider>
);

// Register service worker for PWA offline support
registerServiceWorker();
